import * as React from 'react';
import { usePreferences } from '../Preferences/containers/PreferencesDataStore';
import { useCookies } from 'react-cookie';
import PreferenceType from '../Preferences/PreferenceType';
import PreferenceName from '../Preferences/PreferenceName';
import LandingPagePreference, {
	getLandingPageCookie,
} from '../Preferences/LandingPagePreference';
import { useLocation } from 'react-router-dom';
import paths from '../../paths';
import NavigationAnchor from '../User/NavigationAnchor';
import UserAccountAnchor from '../Navigation/UserAccountAnchor';
import './appHeader.less';

type Cookie = {
	name: string;
	value: string;
	options: {
		domain: string;
		expires: Date;
		sameSite: any;
	};
};

const AppHeader = (): JSX.Element => {
	const { getPreference } = usePreferences();
	const [cookies, setCookie] = useCookies();
	const location = useLocation();

	const landingPageCookie = cookies['treeline.landingpage'];
	let hasLandingPageSetToEPlus: boolean | undefined;
	const isHomePage =
		location.pathname === paths.mainPage() ||
		location.pathname === paths.home();

	React.useEffect(() => {
		handleRedirectBasedOnPreference();
	}, []);

	const handleRedirectBasedOnPreference = () => {
		if (
			typeof landingPageCookie === 'undefined' ||
			landingPageCookie === ''
		) {
			const landingPagePreference = getPreference(
				PreferenceType.landingPage,
				PreferenceName.preferred,
			);

			if (landingPagePreference) {
				const landingPage =
					landingPagePreference.value ===
					LandingPagePreference.EdelweissPlus
						? LandingPagePreference.EdelweissPlus
						: LandingPagePreference.Community;

				const cookie: Cookie = getLandingPageCookie(landingPage);
				setCookie(cookie.name, cookie.value, cookie.options);
			}
		} else {
			hasLandingPageSetToEPlus =
				landingPageCookie === LandingPagePreference.EdelweissPlus;
		}

		if (hasLandingPageSetToEPlus && isHomePage) {
			window.location.href = `${process.env.REACT_APP_EPLUS_LINK_URL}`;
		}
	};

	return (
		<div className="app-header">
			<NavigationAnchor />
			<UserAccountAnchor />
		</div>
	);
};

export default AppHeader;
